import React from 'react';
import { Text } from '@fragments';
import { IconCheck, IconLoader2 } from '@tabler/icons-react';
import './styles.scss';

// Every "pick" the Studio asks for, as full-width compact rows on one seam: the
// prompt input splits into them (and they merge back into it). `type` is
// `action` (each row answers at once, its own icon leads), `single` (radio) or
// `multiple` (checkbox); `pending` spins the row whose answer is on its way.
export default function OptionPicker({ options, type = 'action', label, labelledBy, disabled = false, pending = null, onPick }) {
  const selectable = type !== 'action';
  return <div className={`studio-options is-${type}`} role={type === 'single' ? 'radiogroup' : 'group'} aria-label={labelledBy ? undefined : label} aria-labelledby={labelledBy}>
    {options.map((option, index) => {
      const on = selectable && !!option.selected;
      const mark = pending === option.value ? <IconLoader2 className="studio-option__spinner" />
        : selectable ? <span className="studio-option__check">{on && <IconCheck />}</span>
        : option.icon;
      return <button key={option.value} type="button" className={`studio-option ${on ? 'is-selected' : ''}`}
        role={type === 'single' ? 'radio' : type === 'multiple' ? 'checkbox' : undefined} aria-checked={selectable ? on : undefined}
        data-autofocus={index === 0 ? true : undefined} disabled={disabled} onClick={() => onPick(option.value)}>
        <span className="studio-option__mark" aria-hidden="true">{mark}</span>
        <Text.label className="studio-option__label" contrast={on || !selectable ? 9 : 8}>{option.label}</Text.label>
        {option.hint && <Text.caption className="studio-option__hint" contrast={6}>{option.hint}</Text.caption>}
      </button>;
    })}
  </div>;
}
